import axios from "axios";
import { API } from "@/lib/api";

// Add auth token to all requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.withCredentials = true;
  return config;
});

const PAGINAS_PUBLICAS = [
  "/", "/login", "/register", "/checkout", "/obrigado", "/termos", "/privacidade",
  "/redefinir-senha", "/confirmar-email",
];

function irPara(caminho) {
  if (window.location.pathname !== caminho) window.location.href = caminho;
}

// O acesso vale 24 h. Quando vence, renova pelo refresh (30 dias, renovado a
// cada uso) e repete o pedido, em vez de mandar a pessoa para o login.
let renovando = null;
function renovarSessao() {
  if (!renovando) {
    renovando = axios
      .post(`${API}/auth/refresh`)
      .then((res) => {
        if (res.data?.token) localStorage.setItem("auth_token", res.data.token);
        return true;
      })
      .catch(() => false)
      .finally(() => { setTimeout(() => { renovando = null; }, 0); });
  }
  return renovando;
}

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {};
    const urlPedido = original.url || "";
    const rotaSemRenovar = ["/auth/refresh", "/auth/login", "/auth/logout"].some((r) => urlPedido.includes(r));
    if (error.response?.status === 401 && !original._renovado && !rotaSemRenovar && localStorage.getItem("auth_token")) {
      original._renovado = true;
      if (await renovarSessao()) return axios(original);
    }
    const url = error.config?.url || "";
    const status = error.response?.status;
    const detalhe = String(error.response?.data?.detail || "");
    const paginaPublica = PAGINAS_PUBLICAS.includes(window.location.pathname);
    const rotaDeAuth = url.includes("/auth/") || url.includes("/stripe/");

    if (status === 401 && !rotaDeAuth && !paginaPublica) {
      localStorage.removeItem("auth_token");
      irPara("/login");
    } else if (status === 403 && detalhe.includes("Assinatura inativa")) {
      // Logado, mas sem assinatura em dia: vai para a tela de renovar, sem deslogar.
      irPara("/assinatura");
    } else if (status === 403 && detalhe.includes("duas etapas")) {
      if (window.location.pathname !== "/conta") window.location.href = "/conta?aba=seguranca";
    }
    return Promise.reject(error);
  }
);

export default axios;
